module.exports = __webpack_public_path__ + "img/VetoSans-Light_2.dd831880.svg";